import React from "react";

interface LyneLabelProps {
  name?: string;
  label: string;
  required?: boolean;
}

export const LyneLabel: React.FC<LyneLabelProps> = ({ name, label, required }) => {
  return (
    <label htmlFor={name}>
      {label}
      {required && <span className="text-danger ml-1">*</span>}
    </label>
  );
};
